import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import type { DataLibraryListItemResponse } from '@core/api/workspace/models/dataLibraryListItemResponse';

@Component({
  selector: 'app-data-library-value-cell',
  template: `
    @if (rowData?.kind === 'collection') {
      <button
        type="button"
        class="cursor-pointer border-0 bg-transparent p-0 text-sm font-medium text-primary-600 transition hover:text-primary-700 hover:underline"
        (click)="openCollection($event)">
        {{ rowData?.itemCount ?? 0 }}
        {{ (rowData?.itemCount ?? 0) === 1 ? 'row' : 'rows' }}
      </button>
    } @else {
      <span class="text-sm text-neutral-800">{{ formattedValue }}</span>
    }
  `,
})
export class DataLibraryValueCellComponent {
  private readonly router = inject(Router);

  /** Set by NGL DynamicRenderer. */
  rowData!: DataLibraryListItemResponse;

  get formattedValue(): string {
    const item = this.rowData;
    if (!item || item.kind !== 'variable') {
      return '—';
    }
    if (item.value === null || item.value === undefined) {
      return '—';
    }
    if (typeof item.value === 'boolean') {
      return item.value ? 'True' : 'False';
    }
    return String(item.value);
  }

  openCollection(event: MouseEvent): void {
    event.stopPropagation();
    const id = this.rowData?.id;
    if (!id) {
      return;
    }
    void this.router.navigate(['/data-library/collections', id]);
  }
}
